<template>
  <section class="cart-area pt-120 pb-120">
    <div class="container">

      <div v-if="cartStore.cart_products.length === 0" class="text-center">
        <h3>No Cart Items Found</h3>
        <router-link to="/shop" class="cart-btn mt-20">Continue Shopping</router-link>
      </div>

      <div v-else class="row">
        <div class="col-12">
          <div>
            <div class="table-content table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th class="product-thumbnail">Images</th>
                    <th class="cart-product-name">Product</th>
                    <th class="product-price">Unit Price</th>
                    <th class="product-quantity">Quantity</th>
                    <th class="product-subtotal">Total</th>
                    <th class="product-remove">Remove</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in cartStore.cart_products" :key="item.id">
                    <td class="product-thumbnail">
                      <router-link :to="`/shop-details/${item.id}`">
                        <img :src="item.image" alt="">
                      </router-link>
                    </td>
                    <td class="product-name">
                      <router-link :to="`/shop-details/${item.id}`">{{ item.title }}</router-link>
                    </td>
                    <td class="product-price">
                      <span class="amount">${{ item.price.toFixed(2) }}</span>
                    </td>
                    <td class="product-quantity">
                      <div class="cart-plus-minus">
                        <input type="number" v-model.number="item.orderQuantity" min="1">
                        <div @click="cartStore.quantityDecrement(item)" class="dec qtybutton">-</div>
                        <div @click="cartStore.addCartProduct(item)" class="inc qtybutton">+</div>
                      </div>
                    </td>
                    <td class="product-subtotal" v-if="item.orderQuantity">
                      <span class="amount">Rs.{{ (item.price * item.orderQuantity).toFixed(2) }}</span>
                    </td>
                    <td class="product-remove">
                      <a @click.prevent="cartStore.removeCartProduct(item)" href="#"><i class="fa fa-times"></i></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--
            <div class="row">
              <div class="col-12">
                <div class="coupon-all">
                  <form @submit.prevent="handleCouponSubmit" class="coupon">
                    <input type="text" id="coupon_code" class="input-text" placeholder="Enter Coupon Code" v-model="couponCode">
                    <button class="tp-btn-h1" name="apply_coupon" type="submit">Apply coupon</button>
                  </form>
                  <div class="coupon2">
                    <button @click="cartStore.clear_cart()" class="tp-btn-h1" name="update_cart" type="button">Clear cart</button>
                  </div>
                </div>
              </div>
            </div>
        -->
            <div class="row justify-content-end">
              <div class="col-md-5">
                <div class="cart-page-total">
                  <h2>Cart totals</h2>
                  <ul class="mb-20">
                    <li>Subtotal 
                      <span>Rs. {{ cartStore.totalPriceQuantity.total.toFixed(2) }}</span>
                    </li>
                    <li>Total 
                      <span>Rs. {{ cartStore.totalPriceQuantity.total.toFixed(2) }}</span>
                    </li>
                  </ul>
                  <router-link class="tp-btn-h1" to="/checkout">Proceed to checkout</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import { ref } from "vue";
import { useCartStore } from "@/stores/useCartStore";

export default {
  name: "CartArea",
  setup() {
    const cartStore = useCartStore();
    const couponCode = ref("");

    const handleCouponSubmit = () => {
      console.log(couponCode.value);
    };

    return {
      cartStore,
      couponCode,
      handleCouponSubmit,
    };
  },
};
</script>
